module.exports = __webpack_public_path__ + "static/img/swdl.3851e8e6.png";